import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"

dayjs.extend(customParseFormat)

/**
 * returns at local midnight
 */
export const getFirstDayOfMonth = (minDate: string | Date): Date => {
	const date = new Date(minDate)
	return new Date(date.getFullYear(), date.getMonth(), 1)
}

/**
 * returns at local midnight
 */
export const getFirstDayOfMonthPlusYears = (dateInput: string | Date, years: number): Date => {
	const date = new Date(dateInput)
	return new Date(date.getFullYear() + years, date.getMonth(), 1)
}
